import { TedDomain } from '../app/entry/structure-data.models';
import { colorGallery } from './constants';
type PDBeMolstar = any;

export async function colorByTed(
  viewerInstance: PDBeMolstar,
  tedDomainData: TedDomain[]
) {
  const tedData = [];
  tedDomainData.forEach((item, index) => {
    for (let seg of item.segments) {
      tedData.push({
        struct_asym_id: 'A',
        start_residue_number: seg.af_start,
        end_residue_number: seg.af_end,
        color: colorGallery[(item.ted_domain_no-1) % colorGallery.length],
        // color: colorGallery[index % colorGallery.length],
      });
    }
  });
  const data = tedData;
  const selectionObject = {
    data,
    nonSelectedColor: '#F2F2F2',
  };
  await viewerInstance.visual.select(selectionObject);
}

export async function colorByCustomAnnotations(
  viewerInstance: PDBeMolstar,
  customData
) {
  const customInfo = customData.segments.map((segment) => {
    return {
      struct_asym_id: 'A',
      start_residue_number: segment.start,
      end_residue_number: segment.end,
      color: customData.color,
    }
  });
  const data = customInfo;
  const selectionObject = {
    data,
    nonSelectedColor: '#F2F2F2',
  };
  await viewerInstance.visual.select(selectionObject);
}
